import React, { useEffect, useState } from "react";
import Select from "react-select";
import { Oval } from "../../assets/imagesPath";
import { useForm } from "react-hook-form";
import PhoneInput from 'react-phone-input-2';
import { useNavigate } from "react-router-dom";
import PATHS from "../../routes/Paths";
import { useDispatch, useSelector } from "react-redux";
import { updateBusinessForm } from "../../redux/AuthSlice";
import { prfx, sfx, states } from "../../data/States";

const BasicInfo = () => {
  const initialState = localStorage.getItem("intial_state")
  const [objectData, setObjectData] = useState({
    phone: null,
    enableTabs: false,
    suffixData: "",
    statesData: initialState,
    prefixData: ""
  });

  const handleChange = (field, value) => {
    setObjectData((prevData) => ({
      ...prevData,
      [field]: value
    }));
  };
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const auth = useSelector((data) => data?.auth);
  const formData = auth?.businessDetailForm;
  const customStyles = {
    control: (base) => ({
      ...base,
      backgroundColor: "white",
      border: "1px solid #ddd",
      borderRadius: "10px",
      padding: "5px",
      fontSize: "1.2rem",
      cursor: "pointer",

    }),
    menuList: (provided) => ({ ...provided, paddingTop: 0, paddingBottom: 0, }),
    menu: (base) => ({
      ...base,
      backgroundColor: "#173363",
      borderRadius: "4px",
    }),
    option: (base, state) => ({
      ...base,
      backgroundColor: state.isFocused ? "white" : "#173363",
      color: state.isFocused ? "#173363" : "white",
      cursor: "pointer",
      fontSize: "1.2rem",
      // padding: "8px",
      borderRadius: "4px",

    }),
    indicatorSeparator: () => ({
      display: "none",
    }),
    singleValue: (base) => ({
      ...base,
      color: "black",
      fontSize: "1.6rem",
    }),
  };
  const {
    register,
    setError,
    clearErrors,
    watch,
    reset,
    formState: { errors },
  } = useForm();
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  const { firstName, middleName, lastName, prefferedName, businessName, businessAddress, businessAddressCont, zipCode, city, state, email } = watch();

  const onSubmit = () => {

    const data = {
      basicInformation: {
        firstName: firstName,
        middleName: middleName,
        lastName: lastName,
        prefferedName: prefferedName,
        title: objectData.prefixData,
        suffix: objectData.suffixData,
        businessName: businessName,
        businessAddress: businessAddress,
        businessAddressCont: businessAddressCont,
        city: city,
        state: objectData.statesData,
        zipCode: zipCode,
        emailAddress: email,
        phoneNumber: objectData.phone
      },
    };

    dispatch(updateBusinessForm(data));
    navigate(PATHS.businessDetails);
  };

  const validationHandler = () => {
    let noError = false;

    legalNameValidationHandler();
    businessNameValidationHandler();
    businessAddressValidationHandler();
    zipCodeValidationHandler();
    stateValidationHandler();
    cityValidationHandler();
    emailValidationHandler();
    phoneValidationHandler();

    if (
      firstName &&
      lastName &&
      businessName &&
      businessAddress &&
      zipCode &&
      objectData.statesData &&
      city &&
      email &&
      emailRegex.test(email) &&
      objectData.phone &&
      objectData.phone.length > 10
    ) {
      onSubmit();
      setObjectData((prevData) => ({
        ...prevData,
        enableTabs: true,
      }));
    } else {
      return false;
    }

    return noError;
  };

  const legalNameValidationHandler = () => {
    if (!firstName) {
      setError("firstName", { type: "custom", message: "Legal First Name is required" });
    } else {
      clearErrors("firstName");
    }

    if (!lastName) {
      setError("lastName", { type: "custom", message: "Legal Last Name is required" });
    } else {
      clearErrors("lastName");
    }
  };

  const businessNameValidationHandler = () => {
    if (!businessName) {
      setError("businessName", { type: "custom", message: "Business Name is required" });
    } else {
      clearErrors("businessName");
    }
  };

  const businessAddressValidationHandler = () => {
    if (!businessAddress) {
      setError("businessAddress", { type: "custom", message: "Business Address is required" });
    } else {
      clearErrors("businessAddress");
    }
  };

  const cityValidationHandler = () => {
    if (!city) {
      setError("city", { type: "custom", message: "City is required" });
    } else {
      clearErrors("city");
    }
  };
  const stateValidationHandler = () => {
    if (!objectData.statesData) {
      setError("state", { type: "custom", message: "State is required" });
    } else {
      clearErrors("state");
    }
  };
  const zipCodeValidationHandler = () => {
    if (!zipCode) {
      setError("zipCode", { type: "custom", message: "ZipCode is required" });
    } else {
      clearErrors("zipCode");
    }
  };

  const emailValidationHandler = () => {
    // const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!email) { setError("email", { type: "custom", message: "Email is required" }); }
    else if (!emailRegex.test(email)) { setError("email", { type: "custom", message: "Please enter a valid email address" }); }
    else { clearErrors("email"); }
  };

  const phoneValidationHandler = () => {
    if (!objectData.phone) {
      setError("phone", { type: "custom", message: "Phone number is required" });
    } else if (objectData.phone.length < 11) {
      setError("phone", { type: "custom", message: "Phone number must be at least 11 digits" });
    } else {
      clearErrors("phone");
    }
  };

  useEffect(() => {
    if (formData?.basicInformation) {
      let { fullLegalName, businessName, businessAddress, businessAddressCont, emailAddress, phoneNumber, state, city, zipCode } = formData?.basicInformation;
      reset({ firstName: fullLegalName, businessName, businessAddress, businessAddressCont, state, city, zipCode, email: emailAddress });
      setObjectData((prev) => ({ ...prev, phone: phoneNumber }));

 
    }
  }, [JSON.stringify(formData?.basicInformation)]);

  useEffect(() => {
    if (firstName && lastName && businessName && businessAddress && objectData.statesData && zipCode && city && email && objectData.phone) {
      {
        setObjectData((prev) => ({ ...prev, enableTabs: true }));
      }
    }
  }, [firstName, lastName, businessName, businessAddress, objectData.statesData, zipCode, city, email, objectData.phone]);;

  useEffect(() => {
    if (firstName) clearErrors("fullName");
    // if (middleName) clearErrors("middleName");
    if (lastName) clearErrors("lastName");
    // if (prefferedName) clearErrors("prefferedName");
    // if (suffix) clearErrors("suffix");
    // if (title) clearErrors("title");
    if (businessName) clearErrors("businessName");
    if (businessAddress) clearErrors("businessAddress");
    if (email) clearErrors("email");
    if (objectData.statesData) clearErrors("state");
    if (zipCode) clearErrors("zipCode");
    if (city) clearErrors("city");
    if (objectData.phone) clearErrors("phone");
  }, [firstName, lastName, businessName, businessAddress, email, objectData.phone, objectData.statesData, zipCode, city, clearErrors]);

  return (
    <div className="w-full mb-16">
      <div className="mx-auto text-center mb-10 space-y-4 mt-40 tabsBtn sm:space-y-0 sm:space-x-4">
        <button
          className="w-full sm:w-auto smallScreens:mx-6  px-4 py-5 text-[1.4rem] font-medium rounded-md bg-[#173363] text-[#FFFFFF] border border-[#8188918C]"
          onClick={() => navigate(PATHS.basicInfo)}
        >
          Basic Information
        </button>
        <button
          className="w-full sm:w-auto smallScreens:mx-6 px-4 py-5 text-[1.4rem] font-medium rounded-md bg-[#FFFFFF] text-[#818891] border border-[#8188918C]"
          disabled={!objectData.enableTabs}
          onClick={() => navigate(PATHS.businessDetails)}
        >
          Business Details
        </button>
        <button
          className="w-full sm:w-auto  smallScreens:mx-6 px-4 py-5 text-[1.4rem] font-medium rounded-md bg-[#FFFFFF] text-[#818891] border border-[#8188918C]"
          disabled={!objectData.enableTabs}
          onClick={() => navigate(PATHS.servicesNeeded)}
        >
          Services Needed
        </button>
        <button
          className="w-full sm:w-auto px-4 smallScreens:mx-6 py-5 text-[1.4rem] font-medium rounded-md bg-[#FFFFFF] text-[#818891] border border-[#8188918C]"
          disabled={!objectData.enableTabs}
          onClick={() => navigate(PATHS.clientScreening)}
        >
          Client Screening Questions
        </button>
        <button
          className="w-full sm:w-auto px-4 smallScreens:mx-6 py-5 text-[1.4rem] font-medium rounded-md bg-[#FFFFFF] text-[#818891] border border-[#8188918C]"
          disabled={!objectData.enableTabs}
          onClick={() => navigate(PATHS.businessFormation)}
        >
          Business Formation Decision
        </button>
        <button
          className="w-full sm:w-auto px-4 smallScreens:mx-6 py-5 text-[1.4rem] font-medium rounded-md bg-[#FFFFFF] text-[#818891] border border-[#8188918C]"
          disabled={!objectData.enableTabs}
          onClick={() => navigate(PATHS.additionalDetails)}
        >
          Additional Details
        </button>
      </div>

      <div className="flex justify-center items-center p-16 pb-40 min-h-[50vh]">
        <div className="w-3/4 smallScreens:w-full bg-white mt-20 shadow-2xl rounded-xl p-10 md:p-14 relative">
          <div className="space-y-16">
            <p className="text-red-500 text-[1.3rem] mb-2 font-semibold">
              Enter your full legal name exactly as it appears on official documents to ensure proper processing of your records, including EIN applications.
            </p>
            {/* Row 1: Full Legal Name & Business Name */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label className="block text-[1.4rem] mb-2 text-[#000000] font-medium">
                  Prefix
                </label>
                <div className="relative mt-4">
                  <Select
                    options={prfx}
                    value={prfx?.find((option) => option.value === objectData.prefixData)}
                    onChange={(selectedOption) => handleChange("prefixData", selectedOption.value)}
                    placeholder="Select"
                    styles={customStyles}
                    className="fix_height_input"
                  />

                </div>
              </div>

              <div>
                <label className="block text-[1.4rem] mb-4 text-[#000000] font-medium">
                  Full Legal First Name
                </label>
                <input
                  type="text"
                  placeholder="Enter Your First Name"
                  {...register("firstName")}
                  className="w-full text-[1.6rem] fix_height_input p-4 border-2 border-[#F5F5F2] rounded-2xl focus:outline-none"
                />
                {errors.firstName && (
                  <p className="text-red-500 text-[1.2rem] mt-1">
                    {errors.firstName.message}
                  </p>
                )}
              </div>

              <div>
                <label className="block text-[1.4rem] mb-4 text-[#000000] font-medium">
                  Full Legal Middle Name
                </label>
                <input
                  type="text"
                  placeholder="Enter Your Middle Name"
                  {...register("middleName")}
                  className="w-full text-[1.6rem] fix_height_input p-4 border-2 border-[#F5F5F2] rounded-2xl focus:outline-none"
                />
                {errors.middleName && (
                  <p className="text-red-500 text-[1.2rem] mt-1">
                    {errors.middleName.message}
                  </p>
                )}
              </div>

              <div>
                <label className="block text-[1.4rem] mb-4 text-[#000000] font-medium">
                  Full Legal Last Name
                </label>
                <input
                  type="text"
                  placeholder="Enter Your Last Name"
                  {...register("lastName")}
                  className="w-full text-[1.6rem] fix_height_input p-4 border-2 border-[#F5F5F2] rounded-2xl focus:outline-none"
                />
                {errors.lastName && (
                  <p className="text-red-500 text-[1.2rem] mt-1">
                    {errors.lastName.message}
                  </p>
                )}
              </div>
              <div>
                <label className="block text-[1.4rem] mb-4 text-[#000000] font-medium">
                  Preffered  Name
                </label>
                <input
                  type="text"
                  placeholder="Enter Preffered Name"
                  {...register("prefferedName")}
                  className="w-full text-[1.6rem] fix_height_input p-4 border-2 border-[#F5F5F2] rounded-2xl focus:outline-none"
                />
                {errors.prefferedName && (
                  <p className="text-red-500 text-[1.2rem] mt-1">
                    {errors.prefferedName.message}
                  </p>
                )}
              </div>
              <div>
                <label className="block text-[1.4rem] mb-2 text-[#000000] font-medium">
                  Suffix
                </label>
                <div className="relative mt-4">
                  <Select
                    options={sfx}
                    value={sfx?.find((option) => option.value === objectData.suffixData)}
                    onChange={(selectedOption) => handleChange("suffixData", selectedOption.value)}
                    placeholder="Select"
                    styles={customStyles}
                    className="fix_height_input"
                  />
                </div>
              </div>
              <div>
                <label className="block text-[1.4rem] mb-4 text-[#000000] font-medium">
                  Business Name
                </label>
                <input
                  type="text"
                  placeholder="Enter Your Business Name"
                  {...register("businessName")}
                  className="w-full fix_height_input text-[1.6rem] p-4 border-2 border-[#F5F5F2] rounded-2xl focus:outline-none"
                />
                {errors.businessName && (
                  <p className="text-red-500 text-[1.2rem] mt-1">
                    {errors.businessName.message}
                  </p>
                )}
              </div>

              <div>
                <label className="block text-[1.4rem] mb-4 text-[#000000] font-medium">
                  Email Address
                </label>
                <input
                  type="email"
                  placeholder="Enter Your Email Address"
                  {...register("email")}
                  className="w-full fix_height_input text-[1.6rem] p-4 border-2 border-[#F5F5F2] rounded-2xl focus:outline-none"
                />
                {errors.email && (
                  <p className="text-red-500 text-[1.2rem] mt-1">
                    {errors.email.message}
                  </p>
                )}
              </div>

              <div>
                <label className="block text-[1.4rem] mb-4 text-[#000000] font-medium">
                  Phone Number
                </label>
                <PhoneInput
                  country="us"
                  onlyCountries={["us"]}
                  value={objectData.phone}
                  onChange={(phone) => handleChange("phone", phone)}
                  className="w-full react_custom_phone"
                  inputStyle={{
                    width: "100%",
                    paddingTop: "18px",
                    paddingBottom: "18px",
                    border: "2px solid #F5F5F2",
                    borderRadius: "1rem",
                  }}
                />

                {errors.phone && (
                  <p className="text-red-500 text-[1.2rem] mt-1">
                    {errors.phone.message}
                  </p>
                )}
              </div>

              <div>
                <label className="block text-[1.4rem] mb-4 text-[#000000] font-medium">
                  Address
                </label>
                <input
                  type="text"
                  placeholder="Enter Your Business Address"
                  {...register("businessAddress")}
                  className="w-full fix_height_input text-[1.6rem] p-4 border-2 border-[#F5F5F2] rounded-2xl focus:outline-none"
                />
                {errors.businessAddress && (
                  <p className="text-red-500 text-[1.2rem] mt-1">
                    {errors.businessAddress.message}
                  </p>
                )}
              </div>
              <div>
                <label className="block text-[1.4rem] mb-4 text-[#000000] font-medium">
                  Address Cont.
                </label>
                <input
                  type="text"
                  placeholder="Enter Your Business Address"
                  {...register("businessAddressCont")}
                  className="w-full fix_height_input text-[1.6rem] p-4 border-2 border-[#F5F5F2] rounded-2xl focus:outline-none"
                />
              </div>

              <div>
                <label className="block text-[1.4rem] mb-4 text-[#000000] font-medium">
                  City
                </label>
                <input
                  type="text"
                  placeholder="Enter City"
                  {...register("city")}
                  className="w-full fix_height_input text-[1.6rem] p-4 border-2 border-[#F5F5F2] rounded-2xl focus:outline-none"
                />
                {errors.city && (
                  <p className="text-red-500 text-[1.2rem] mt-1">
                    {errors.city.message}
                  </p>
                )}
              </div>
              <div>
                <label className="block text-[1.4rem] mb-4 text-[#000000] font-medium">Select State</label>
                <div className="relative mt-4 custom-scrollbar focus:outline-none">
                  <Select
                    options={states}
                    styles={customStyles}
                    value={states?.find((option) => option.value === objectData.statesData)}
                    onChange={(selectedOption) => handleChange("statesData", selectedOption.value)}
                    placeholder="States"
                    classNamePrefix="custom-select"
                  />
                </div>
                {errors.state && (
                  <p className="text-red-500 text-[1.2rem] mt-1">
                    {errors.state.message}
                  </p>
                )}
              </div>

              <div>
                <label className="block text-[1.4rem] mb-4 text-[#000000] font-medium">
                  Zip Code
                </label>
                <input
                  type="number"
                  placeholder="Enter Zip Code"
                  {...register("zipCode")}
                  className="w-full fix_height_input text-[1.6rem] p-4 border-2 border-[#F5F5F2] rounded-2xl focus:outline-none"
                />
                {errors.zipCode && (
                  <p className="text-red-500 text-[1.2rem] mt-1">
                    {errors.zipCode.message}
                  </p>
                )}
              </div>

            </div>

            <div className="text-center">
              <button
                type="button"
                className="w-2/3 text-[1.6rem] bg-[#173363] text-white py-4 rounded-lg"
                onClick={validationHandler}
              >
                Save
              </button>
            </div>
          </div>

          <div className="absolute -top-20 -right-20 h-[10rem] w-[10rem] z-[-1]">
            <img src={Oval} alt="oval-img" />
          </div>
        </div>

      </div>
    </div>
  );
};

export default BasicInfo;